/**
 * UI-6b Task 10 — CsatScore widget manifest.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import { CsatScoreRenderer, type CsatScoreConfig } from './Renderer.js'
import { CsatScoreConfigEditor } from './ConfigEditor.js'

export const csatScoreManifest: WidgetManifest<CsatScoreConfig> = {
  type: 'csat-score',
  label: 'CSAT Score',
  description: 'Average customer satisfaction (0-5) over a recent window.',
  defaultSize: '1x1',
  defaultConfig: { days: 7 },
  Renderer: CsatScoreRenderer,
  ConfigEditor: CsatScoreConfigEditor,
}

registerWidget(csatScoreManifest)
